export interface NewTrainingDetails {
    objectives: string,
    required_level: string,
    concerned_public: string,
    program: NewProgram[]
}

export interface technologies {
    id: number,
    title: string,
    duration: string,
    description: string,
    price: number,
    tag: string,
}

export interface PopularTags {
    id: number,
    state: string,
    demanded: string,
}

export interface NewTraining {
    id: number,
    type: string,
    title: string,
    description: string,
    icon: string,
    include: string[],
    duration: string,
    slug: string,
    trainingPlaces: string[],
    category: string[],
    min_price: number,
    technologies: technologies[],
    popularTags: PopularTags[],
    // trainingDetails?: NewTrainingDetails
}

export interface NewProgram {
    title: string,
    content: NewContent[]
}

export interface NewContent {
    title: string,
    text: string
}

export const newTrainings: NewTraining[] = [
    {
        id: 0,
        type: "catalog",
        title: "Développement Logiciel",
        description: "Pour ingénieurs systèmes et équipes IT en charge de l'infrastructure et du déploiement.",
        icon: "https://www.pngitem.com/pimgs/m/421-4213978_icon-training-icon-training-icon-png-download.png",
        include: [],
        duration: "4-5 jours",
        slug: "developpement-logiciel",
        trainingPlaces: [
            'online',
            'face-to-face'
        ],
        category: [
            'management'
        ],
        min_price: 900000,
        technologies: [
            {
                id: 0,
                title: "Java",
                duration: "4 jours",
                description: "Conteneurisation et Orcherstration",
                price: 900000,
                tag: "java",
            },
            {
                id: 1,
                title: "Python",
                duration: "5 jours",
                description: "Programmation orientée objet",
                price: 1000000,
                tag: "python",
            },
            {
                id: 2,
                title: "JavaScript",
                duration: "4 jours",
                description: "Développement web front-end",
                price: 1100000,
                tag: "javascript",
            }
        ],
        popularTags: [
            {
                id: 0,
                state: "Nouveau",
                demanded: "Développement logiciel"
            },
            {
                id: 1,
                state: "Nouveau",
                demanded: "Développement logiciel"
            },
            {
                id: 2,
                state: "Terminé",
                demanded: "Administration système"
            }
        ],
    },
    {
        id: 1,
        type: "catalog",
        title: "Cloud & DevOps",
        description: "Pour ingénieurs systèmes et équipes IT en charge de l'infrastructure et du déploiement.",
        icon: "https://www.pngitem.com/pimgs/m/421-4213978_icon-training-icon-training-icon-png-download.png",
        include: [],
        duration: "4-5 jours",
        slug: "developpement-logiciel",
        trainingPlaces: [
            'online',
            'face-to-face'
        ],
        category: [
            'management'
        ],
        min_price: 100,
        technologies: [
            {
                id: 0,
                title: "Java",
                duration: "4 jours",
                description: "Conteneurisation et Orcherstration",
                price: 900000,
                tag: "java",
            },
            {
                id: 1,
                title: "Python",
                duration: "5 jours",
                description: "Programmation orientée objet",
                price: 1000000,
                tag: "python",
            },
            {
                id: 2,
                title: "JavaScript",
                duration: "4 jours",
                description: "Développement web front-end",
                price: 1100000,
                tag: "javascript",
            }
        ],
        popularTags: [
            {
                id: 0,
                state: "En cours",
                demanded: "Développement logiciel"
            },
            {
                id: 1,
                state: "En cours",
                demanded: "Développement logiciel"
            },
            {
                id: 2,
                state: "Terminé",
                demanded: "Administration système"
            }
        ],
    },
    {
        id: 2,
        type: "packEnterprise",
        title: "Pack Transformation Digitale",
        description: "Programme complet pour accompagner une entreprise dans sa montée en compétences IT. Audit, plan de formation personnalisé et sessions pour les équipes.",
        icon: "https://www.pngitem.com/pimgs/m/421-4213978_icon-training-icon-training-icon-png-download.png",
        include: [
            "Audit des compétences IT existantes",
            "Plan de formation sur mesure (12 mois)",
            "Sessions de formation pour les équipes (intra)",
            "Attestations de formation remises",
            "Suivi et accompagnement post-formation"
        ],
        duration: "4-5 jours",
        slug: "developpement-logiciel",
        trainingPlaces: [
            'online',
            'face-to-face'
        ],
        category: [
            'management'
        ],
        min_price: 100,
        technologies: [
            {
                id: 0,
                title: "Java",
                duration: "4 jours",
                description: "Conteneurisation et Orcherstration",
                price: 900000,
                tag: "java",
            },
            {
                id: 1,
                title: "Python",
                duration: "5 jours",
                description: "Programmation orientée objet",
                price: 1000000,
                tag: "python",
            },
            {
                id: 2,
                title: "JavaScript",
                duration: "4 jours",
                description: "Développement web front-end",
                price: 1100000,
                tag: "javascript",
            }
        ],
        popularTags: [
            {
                id: 0,
                state: "En cours",
                demanded: "Développement logiciel"
            },
            {
                id: 1,
                state: "En cours",
                demanded: "Développement logiciel"
            },
            {
                id: 2,
                state: "Terminé",
                demanded: "Administration système"
            }
        ],
    },
    {
        id: 3,
        type: "packEnterprise",
        title: "Pack Cybersécurité Entreprise",
        description: "Audit de sécurité + formation des équipes IT + plan de remédiation. Idéal pour les entreprises qui veulent protéger leur SI de manière durable.",
        icon: "https://www.pngitem.com/pimgs/m/421-4213978_icon-training-icon-training-icon-png-download.png",
        include: [
            "Audit cybersécurité complet",
            "Formation sécurité réseau & incidents",
            "Sensibilisation collaborateurs",
            "Plan de remédiation priorisé"
        ],
        duration: "4-5 jours",
        slug: "developpement-logiciel",
        trainingPlaces: [
            'online',
            'face-to-face'
        ],
        category: [
            'management'
        ],
        min_price: 2000000,
        technologies: [
            {
                id: 0,
                title: "Java",
                duration: "4 jours",
                description: "Conteneurisation et Orcherstration",
                price: 900000,
                tag: "java",
            },
            {
                id: 1,
                title: "Python",
                duration: "5 jours",
                description: "Programmation orientée objet",
                price: 1000000,
                tag: "python",
            },
            {
                id: 2,
                title: "JavaScript",
                duration: "4 jours",
                description: "Développement web front-end",
                price: 1100000,
                tag: "javascript",
            }
        ],
        popularTags: [
            {
                id: 0,
                state: "En cours",
                demanded: "Développement logiciel"
            },
            {
                id: 1,
                state: "En cours",
                demanded: "Développement logiciel"
            },
            {
                id: 2,
                state: "Terminé",
                demanded: "Administration système"
            }
        ],
    },
];